import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class AbonelerAPI extends BaseAPI {
    constructor() {
        const baseUrl = environment.API_URL + "AbonelerListe";
        super(baseUrl);
    }

    getAbonelerListe(durumu: number,sicilKodu: number) {

        var request = new AbonelerListeRequest(durumu,sicilKodu);
        return this.post("", request, false);

    }
}
export default new AbonelerAPI();
class AbonelerListeRequest {
    public durumu: number;
    public sicilKodu: number;
    constructor(durumu: number,sicilKodu: number) {

        this.durumu = durumu;
        this.sicilKodu = sicilKodu;
    }
}
export { AbonelerListeRequest };
